import { Formik, Form, ErrorMessage } from "formik";
import React, {useState, useEffect} from "react";
import Popup from "reactjs-popup";
import NumberInputItem from "../numberInputItem";
import '../../../css/App.css'


import IronReplacement from "./ironReplacement";
import { Box, Typography } from "@mui/material";
import IronDeficiencyForm from "./irondeficiencyform";

function IdAnaemia(props){



const [show,setShow]=useState(false)
const [idMessage,setIdMessage]=useState("")
const [ironReplacement, setIronReplacement] = useState(false)
const [riseWithIron,setRiseWithIron]=useState(false)
const [showForm, setShowForm]= useState(true)
const [ironReplacementSubmitted, setIronReplacementSubmitted] = useState(false)
const [idaFormSubmitted,setIdaFormSubmitted]=useState(false)
const [idaFormValues, setIdaFormValues] = useState()

useEffect(()=>{setShow(props.showIdAnaemia)},[props.showIdAnaemia])
   
useEffect(()=>{
if (idaFormSubmitted)
    {
    let idaValues = {...idaFormValues}
    idaValues.ironReplacement=ironReplacement
    idaValues.riseWithIron=riseWithIron
    props.setIdaValues(idaValues)
    setIdMessage("")
    setIronReplacement(false)
    setRiseWithIron(false)
    setIronReplacementSubmitted(false)
    setIdaFormSubmitted(false)
    setIdaFormValues()
    setShow(false)
 
    }
},[idaFormSubmitted,idaFormValues])

return(
<Popup  open={show} position= {"center center"} closeOnDocumentClick={false} closeOnEscape="true">
<div className="popup"> 
<h2>Check if it's Iron Deficiciency Anaemia</h2> 

 <div>
  {!ironReplacementSubmitted && <IronReplacement setIronReplacement={setIronReplacement} setRiseWithIron={setRiseWithIron} setIronReplacementSubmitted={setIronReplacementSubmitted}/>}
 </div>
 {ironReplacement &&  <Typography> Please use blood values from BEFORE Iron Replacement was started </Typography>}
 <Box>
  { ironReplacementSubmitted && <IronDeficiencyForm ironReplacement={ironReplacement} riseWithIron={riseWithIron} sex={props.sex} setIdMessage={setIdMessage}  setIdaFormValues={setIdaFormValues}  setIdaFormSubmitted={setIdaFormSubmitted} setAnaemia={props.setAnaemia}/>}
 </Box>
 <p className ="popupMessage">{idMessage}</p>
 </div>

</Popup>
)
}

export default IdAnaemia


/* Not IDA if Hb >120 in women or 130 in men

`               2) Not IDA if ferritin >150 

                3) Not IDA if ferritin >45: -
UNLESS either:

a)	TIBC is >75 AND %Sat is <20%.
OR
b)	Documented Hb rise of >10g/l with trial of iron.*/
